import { ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import BackIcon from "../../assets/icons/BackIcon";

type TitleBarProps = {
  title: string;
  leftChildren?: ReactNode;
  children?: ReactNode;
  backLink?: string;
  className?: string;
  titleClassName?:string;
};

export default function TitleBar({
  title,
  leftChildren,
  children,
  backLink,
  className,
  titleClassName
}: TitleBarProps) {
  const navigate = useNavigate();
  return (
    <div className={`flex justify-between items-center mb-4 ${className}`}>
      <div className="flex items-center gap-3">
        {backLink &&
          (backLink === "-1" ? (
            <button onClick={() => navigate(-1)}>
              <BackIcon />
            </button>
          ) : (
            <Link to={backLink}>
              <BackIcon />
            </Link>
          ))}
        <h4 className={`text-[#1C222B] text-[22px] font-medium ${titleClassName}`}>{title}</h4>
        {leftChildren}
      </div>

      {children}
    </div>
  );
}
